import axios from 'axios';

import routes from 'app/routes';

export default {
  update: (managerId, values, withFormData, successCallback, errorCallback) => {
    if (withFormData) {
      const formData = new FormData();

      if (typeof values.avatar === 'string') {
        delete values.avatar;
      }

      Object.keys(values).forEach((key) => {
        formData.append(key, values[key] === null ? '' : values[key]);
      });

      axios
        .put(routes.api.managers.profile.update(managerId), formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((resp) => {
          successCallback(resp.data.data);
        }).catch((error) => {
          errorCallback(error.response.data);
        });
    } else {
      axios
        .put(routes.api.managers.profile.update(managerId), values)
        .then((resp) => {
          successCallback(resp.data.data);
        }).catch((error) => {
          errorCallback(error.response.data);
        });
    }
  },
};
